<template>
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    <div class="container-fluid">
      <a class="navbar-brand" href="#"><img src="../assets/logo-sm-icon.png" /></a>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav">
          <li class="nav-item">
            <router-link class="nav-link active" to="/">Home</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/assessments">Send</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/dispatched">Sent</router-link>
          </li>  
          <li class="nav-item">
            <router-link class="nav-link" to="/candidates">Completed</router-link>
          </li>       
          <!--<li class="nav-item">
            <router-link class="nav-link" to="/settings">Settings</router-link>
          </li>-->
          <li v-if="!userIsUnlimitedSubscriber" class="nav-item">
            <router-link class="nav-link unlimited-link-style" aria-current="page" to="/get-unlimited"><strong>Get Unlimited!</strong></router-link>
          </li>
          <li v-if="adminRole" class="nav-item">
            <router-link class="nav-link" aria-current="page" to="/invite">Invite</router-link>
          </li>
        <!--<ul class="navbar-nav ml-auto"> <!-- ml-auto to align right -->
          <li class="nav-item" style="float: right;">
            <a class="nav-link" href="#" @click="logout()">Logout</a>
          </li>
        <!--</ul>-->
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import { getCookie, deleteAllCookies } from '@/utils/cookies/cookieUtils.js';
import { endpoint  } from '@/utils/endpoint/endpointUtils';
import { adminRole } from '@/utils/roles/roles.js';
export default {  
  async mounted() {
    await this.checkIfSubscriber();

    // "Are they subscribing?" available outside of element.
    this.$emit('user-subscriber-status', this.userIsUnlimitedSubscriber);
    await this.checkIfAdmin();
  },
  data() {
    return {
      userIsUnlimitedSubscriber: false,
      adminRole: false
    };
  },
  methods: {
    async checkIfAdmin() {
      const userid = getCookie('userid');
      const token = getCookie('token');

      this.adminRole = await adminRole(userid, token, endpoint);
    },
    async checkIfSubscriber() {
      const userid = getCookie('userid');
      const token = getCookie('token');

      try {  
      const response = await fetch(endpoint + '/api/User/UserIsSubscriber?userid=' + userid, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json',
        },
        //body: JSON.stringify(body)
      });
    
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
        // Maybe fix the CORs issues?
      }
    
      const data = await response.json();
      this.userIsUnlimitedSubscriber = data.isSubscriber;

      } catch(exception) {
        console.log(exception);
      }
    },
    logout() {
      // Deleting cookies, forcing logout.
      deleteAllCookies();
    }
  }
};
</script>
<style scoped>
.unlimited-link-style {
  color:coral;
}
</style>